@use "../../styling/form-controls.scss" as *;
@use "../../styling/colors.scss" as *;

.Tooltips {
  @extend %form-control-label-font;

  position: relative;

  .TooltipLegend {
    display: flex;
    column-gap: 14px;
    position: absolute;

    > span:first-child {
      visibility: hidden;
    }
  }
}

.FieldLabel {
  width: 100%;

  .Legend {
    display: flex;
  }

  .Label {
    @extend %form-control-label-font;

    display: inline-flex;
    padding-bottom: 8px;
    align-items: center;
    z-index: 1;

    > span:first-child {
      display: flex;
      width: 14px;
    }
  }

  input,
  select {
    width: 100%; // fill the width of the label container
  }

  .Tooltips {
    padding-left: 1em;

    svg path {
      color: $theme-color-header;
    }
  }

  &.isCondensed { // Nested field label
    font-size: smaller;
    color: $color-grey-B;
  }
}
